const TONES = {
  neutral: ['bg-catering-cream-300 text-catering-ink-700', 'bg-catering-ink-500'],
  ink: ['bg-catering-ink-900 text-catering-cream-100', 'bg-catering-lemon'],
  lemon: ['bg-catering-lemon-300 text-catering-ink-900', 'bg-catering-ink-900'],
  success: ['bg-catering-herb-100 text-catering-herb-600', 'bg-catering-herb-500'],
  warning: ['bg-catering-honey-100 text-catering-honey-600', 'bg-catering-honey-500'],
  danger: ['bg-catering-berry-100 text-catering-berry-600', 'bg-catering-berry-500'],
  tomato: ['bg-catering-tomato-100 text-catering-tomato-600', 'bg-catering-tomato-500']
}

export function pillClasses(tone = 'neutral', size = 'md') {
  const [palette, dot] = TONES[tone] || TONES.neutral
  const sizing = size === 'sm' ? 'px-2 py-0.5 text-xxs' : 'px-2.5 py-1 text-xs'
  return {
    wrap: `inline-flex items-center gap-1.5 rounded-full font-catering-body font-semibold leading-tight whitespace-nowrap ${palette} ${sizing}`,
    dot: `h-1.5 w-1.5 rounded-full ${dot}`
  }
}
